// URL share-server API
const SHARE_SERVER_URL = import.meta.env.VITE_SHARE_SERVER_URL || 'http://localhost:3002';

let csrfToken: string | null = null;
let csrfPromise: Promise<string> | null = null; // Добавляем кэширование промиса

// Функция для получения CSRF токена из cookie (для совместимости)
function getCsrfTokenFromCookie(): string | null {
  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === 'XSRF-TOKEN') {
      return decodeURIComponent(value);
    }
  }
  return null;
}

// Получение CSRF токена с сервера
export async function getCsrfToken(): Promise<string> {
  // Если токен уже есть, возвращаем его
  if (csrfToken) {
    console.log('CSRF: Возвращаем кэшированный токен');
    return csrfToken;
  }

  // Если запрос уже в процессе, возвращаем тот же промис
  if (csrfPromise) {
    console.log('CSRF: Запрос уже в процессе, ждем...');
    return csrfPromise;
  }

  console.log('CSRF: Делаем новый запрос токена');
  
  // Создаем новый промис для запроса
  csrfPromise = fetch(`${SHARE_SERVER_URL}/api/csrf-token`, {
    method: 'GET',
    credentials: 'include', // Важно для работы с cookie
    headers: {
      'Content-Type': 'application/json',
    }
  })
  .then(response => {
    if (!response.ok) {
      throw new Error(`HTTP ошибка: ${response.status}`);
    }
    return response.json();
  })
  .then(_data => {
    // Получаем токен из cookie после установки сервером
    const tokenFromCookie = getCsrfTokenFromCookie();
    if (!tokenFromCookie) {
      throw new Error('CSRF токен не найден в cookie после запроса');
    }
    
    csrfToken = tokenFromCookie;
    console.log('CSRF: Токен получен из cookie и сохранен');
    return csrfToken;
  })
  .catch(error => {
    console.error('Ошибка получения CSRF токена:', error);
    throw new Error('Не удалось получить CSRF токен');
  })
  .finally(() => {
    // Очищаем промис после завершения
    csrfPromise = null;
  });

  return csrfPromise;
}

// Сброс CSRF токена (например, при ошибке)
export function resetCsrfToken(): void {
  console.log('CSRF: Сброс токена');
  csrfToken = null;
  csrfPromise = null; // Также сбрасываем промис
}

// Получение текущего CSRF токена (без запроса к серверу)
export function getCurrentCsrfToken(): string | null {
  // Сначала проверяем кэш, потом cookie
  if (csrfToken) {
    return csrfToken;
  }
  
  const tokenFromCookie = getCsrfTokenFromCookie();
  if (tokenFromCookie) {
    csrfToken = tokenFromCookie;
    return csrfToken;
  }
  
  return null;
} 